import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  date: {
    color: theme.palette.secondary.tint40,
  },
  emptyText: {
    textAlign: "center",
  },

  coinTitle: {
    color: theme.palette.secondary.tint40,
    marginLeft: theme.spacing(3),
  },

  wrapperLastCol: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  xBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.spacing(10),
    padding: theme.spacing(4),
    borderRadius: theme.spacing(4),
    marginRight: theme.spacing(4),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.red2.main,
      color: theme.palette.white.main,
    },
  },
  detailBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.spacing(8),
    borderRadius: theme.spacing(4),
    height: theme.spacing(15),
    width: theme.spacing(15),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.white.main,
    },
  },
  orderTypeWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  orderTypeIconDown: {
    color: theme.palette.primary.main,
    fontSize: theme.fontSize["16"],
    margin: theme.spacing(0, 1),
  },
  orderTypeIconUp: {
    color: theme.palette.red.main,
    fontSize: theme.fontSize["16"],
    margin: theme.spacing(0, 1),
  },
  currencyContainer: {
    display: "flex",
    justifyContent: "center",
  },
  popOver: {
    maxWidth: theme.spacing(150),
    minHeight: theme.spacing(61),
    padding: theme.spacing(10),
    backgroundColor: theme.palette.black.main,
    color: theme.palette.secondary.tint15,
    direction: "ltr",
  },
  popOverContainer: {
    marginTop: -theme.spacing(15),
  },
  closeIcon: {
    backgroundColor: theme.palette.red.main,
    borderRadius: "50%",
  },
  popOverText: {
    color: theme.palette.secondary.tint15,
  },
  input: {
    width: theme.spacing(90),
    height: theme.spacing(15),
    padding: 0,
    backgroundColor: theme.palette.secondary.tint90,
    "& .Mui-disabled": {
      backgroundColor: "inherit !important",
      height: [theme.spacing(15), "!important"],
    },
    "& input": {
      color: theme.palette.secondary.tint15,
    },
  },
  seperator: {
    margin: theme.spacing(0, 2),
  },
  orderTypeWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  orderTypeIconDown: {
    color: theme.palette.primary.main,
    fontSize: theme.fontSize["16"],
    margin: theme.spacing(0, 1),
  },
  orderTypeIconUp: {
    color: theme.palette.red.main,
    fontSize: theme.fontSize["16"],
    margin: theme.spacing(0, 1),
  },
  coinLogoAndText: {
    display: "flex",
    alignItems: "center",
  },
}));
